import { ChangeDetectionStrategy, Component } from '@angular/core';
import { WebSocketService } from '../../services/websocket.service';
import { CommonModule } from '@angular/common';
import { LoggingService } from '../../services/logging/logging.service';
import { v4 as uuidv4 } from 'uuid'; // You might need to install this: npm install uuid @types/uuid
import { DemoOperationType, demoOperations } from '../demo-thought-tracer-data';

@Component({
  selector: 'app-demo-thought-tracer-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './demo-thought-tracer-button.component.html',
  styleUrls: ['./demo-thought-tracer-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class DemoThoughtTracerButtonComponent {
  isActive = false;
  demoOperationType = '';

  constructor(
    private webSocketService: WebSocketService,
    private logger: LoggingService
  ) {}

  simulateProgressUpdates(mode: 'realistic' | 'fast'): void {
    if (this.isActive) {
      return;
    }
    this.isActive = true;
    const operationId = uuidv4();
    const operationTypes = Object.keys(demoOperations) as DemoOperationType[];
    const operationType = operationTypes[Math.floor(Math.random() * operationTypes.length)];
    this.demoOperationType = operationType;
    const steps = demoOperations[operationType];
    this.logger.info('DemoButton', `Starting simulated ${mode} demo for operation type: ${operationType}`, {
      operationId,
      operationType,
      mode
    });
    const timeFactor = mode === 'fast' ? 0.1 : 1;
    let stepIndex = 0;
    let progress = 0;
    let cumulativeDelay = 0;
    const simulateStep = () => {
      if (stepIndex < steps.length) {
        const step = steps[stepIndex];
        if (stepIndex === steps.length - 1) {
          progress = 100;
        } else {
          progress = Math.min(95, Math.round((stepIndex / (steps.length - 1)) * 100));
        }
        const update = {
          operationId,
          type: operationType,
          progress,
          message: step.message,
          title: operationType
        };
        this.webSocketService.handleProgressUpdate(update);
        stepIndex++;
        cumulativeDelay += step.delay * timeFactor;
        if (stepIndex < steps.length) {
          setTimeout(simulateStep, step.delay * timeFactor);
        } else {
          setTimeout(() => {
            this.isActive = false;
            this.demoOperationType = '';
            this.logger.info('DemoButton', 'Completed simulated progress updates', {
              operationType,
              totalTime: cumulativeDelay
            });
          }, 1000);
        }
      }
    };
    simulateStep();
  }
}